import Pill from "glesys-controlpanel/components/pill";
import PillWarning from "glesys-controlpanel/components/pill/warning";
import DnsDomainStateLabel from "glesys-controlpanel/components/dns-domain-state-label";
import GButtonLinkTo from "glesys-controlpanel/components/g-button/link-to";
import StatusIndicator from "glesys-controlpanel/components/status-indicator";
import { t } from "ember-intl";
import TableTd from "glesys-controlpanel/components/table/td";

<template>
  <TableTd data-test-dns-domain-row={{@domain.id}}>
    {{@domain.displayname}}
  </TableTd>
  <TableTd>
    {{#if @domain.usingglesysnameserver}}

      <Pill class="my-2" @text="Glesys" />
    {{else}}
      <PillWarning class="my-2" @text={{t "label.other-provider"}} />
    {{/if}}
  </TableTd>
  <TableTd>
    {{#if @domain.isManagedByGlesys}}
      <DnsDomainStateLabel class="my-2" @domain={{@domain}} />
    {{else}}
      <PillWarning class="my-2" @text={{t "label.other-provider"}} />
    {{/if}}
  </TableTd>
  <TableTd>
    {{#if @domain.isManagedByGlesys}}
      <StatusIndicator
        class="mx-8"
        data-test-dns-domain-row-auto-renew-status-indicator={{@domain.id}}
        @status={{@domain.autoRenewalStatusIndicator}}
      />
    {{/if}}
  </TableTd>
  <TableTd class="flex items-center justify-end pt-3 pb-3">
    {{#if @domain.id}}
      <GButtonLinkTo @color="gray" @route="dns.domain" @model={{@domain.id}}>
        {{t "button.manage"}}
      </GButtonLinkTo>
    {{/if}}
  </TableTd>
</template>
